/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

export const onRouteUpdate = function ({ location, prevLocation }) {
    // console.log("onRouteUpdate");
    document.body.setAttribute('data-path', location.pathname);

    const scroller = document.getElementById("scroller");
    if (scroller && scroller.scrollTo) {
        scroller.scrollTo(0, 0);
    }
};

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
    if (location.hash && location.hash.length && location.action === "POP") {
        // If an anchor link was clicked, we don't want to scroll at all
    } else {
        // window.scrollTo(0, 0);
    }
    return false;
};

export const onClientEntry = async () => {
    // console.log("onClientEntry");

};

export const onInitialClientRender = () => {
    // console.log("onInitialClientRender");
};
